"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("card/reward/base"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _decorators = require("decorators");

var RewardBadgeCard =
/*#__PURE__*/
function (_RewardCard) {
  babelHelpers.inherits(RewardBadgeCard, _RewardCard);

  function RewardBadgeCard() {
    babelHelpers.classCallCheck(this, RewardBadgeCard);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(RewardBadgeCard).apply(this, arguments));
  }

  return RewardBadgeCard;
}(_base.default);

exports.default = RewardBadgeCard;